(function () {
  function formatTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${String(secs).padStart(2, '0')}`;
  }

  function ensureControls(media) {
    if (!media || media.dataset.customControlsReady === 'true') return;

    const video = media.querySelector('video');
    if (!video) return;

    media.dataset.customControlsReady = 'true';
    video.controls = false;
    video.removeAttribute('controls');

    const controls = document.createElement('div');
    controls.className = 'custom-video-controls';
    controls.innerHTML = `
      <button type="button" class="custom-video-controls__button" data-action="play" aria-label="Pause video"></button>
      <span class="custom-video-controls__time">0:00</span>
      <input class="custom-video-controls__progress" type="range" min="0" max="1000" value="0" step="1" aria-label="Video progress">
      <span class="custom-video-controls__time" data-role="duration">0:00</span>
      <button type="button" class="custom-video-controls__button" data-action="mute" aria-label="Unmute video"></button>
      <button type="button" class="custom-video-controls__button" data-action="fullscreen" aria-label="Enter fullscreen"></button>
    `;

    media.appendChild(controls);

    const playButton = controls.querySelector('[data-action="play"]');
    const muteButton = controls.querySelector('[data-action="mute"]');
    const fullscreenButton = controls.querySelector('[data-action="fullscreen"]');
    const progress = controls.querySelector('.custom-video-controls__progress');
    const currentTime = controls.querySelector('.custom-video-controls__time');
    const duration = controls.querySelector('[data-role="duration"]');
    const icons = {
      play: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.14v13.72L19 12 8 5.14Z"/></svg>',
      pause: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h3v14H7zm7 0h3v14h-3z"/></svg>',
      mute: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 5.23v13.54a1 1 0 0 1-1.64.77L8.91 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.91l3.45-3.54A1 1 0 0 1 14 5.23Zm3.59 2.99L19 9.63 16.63 12 19 14.37l-1.41 1.41L15.22 13.4l-2.37 2.38-1.41-1.41L13.81 12l-2.37-2.37 1.41-1.41 2.37 2.37 2.37-2.37Z"/></svg>',
      unmute: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M14 5.23v13.54a1 1 0 0 1-1.64.77L8.91 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.91l3.45-3.54A1 1 0 0 1 14 5.23Zm2.5 3.27a1 1 0 0 1 1.41 0A4.98 4.98 0 0 1 19.5 12a4.98 4.98 0 0 1-1.59 3.5 1 1 0 1 1-1.32-1.5A2.98 2.98 0 0 0 17.5 12c0-.82-.33-1.56-.91-2.09a1 1 0 0 1-.09-1.41Z"/></svg>',
      fullscreen: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 14H5v5h5v-2H7v-3Zm0-4h2V7h3V5H5v5Zm10 7h-3v2h5v-5h-2v3Zm0-12h-3v2h3v3h2V5h-2Z"/></svg>',
      fullscreenExit: '<svg class="custom-video-controls__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 16H5v3h3v-2h2v-2H8v1Zm0-8h2V5H8v1H5v3h3V8Zm8 9h-2v2h3v-3h-1v1Zm-2-12v2h2v2h1V5h-3Z"/></svg>'
    };

    function updatePlayState() {
      playButton.innerHTML = video.paused ? icons.play : icons.pause;
      playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    }

    function updateMuteState() {
      muteButton.innerHTML = video.muted ? icons.mute : icons.unmute;
      muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    function updateFullscreenState() {
      const isFullscreen = document.fullscreenElement === media || document.fullscreenElement === video;
      fullscreenButton.innerHTML = isFullscreen ? icons.fullscreenExit : icons.fullscreen;
      fullscreenButton.setAttribute('aria-label', isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen');
    }

    function updateDuration() {
      duration.textContent = formatTime(video.duration);
    }

    function updateProgress() {
      currentTime.textContent = formatTime(video.currentTime);
      if (video.duration) {
        progress.value = Math.round((video.currentTime / video.duration) * 1000);
      } else {
        progress.value = 0;
      }
      progress.style.setProperty('--progress-percent', `${progress.value / 10}%`);
    }

    function seekFromInput() {
      if (!video.duration) return;
      video.currentTime = (Number(progress.value) / 1000) * video.duration;
    }

    playButton.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    muteButton.addEventListener('click', function () {
      video.muted = !video.muted;
      updateMuteState();
    });

    fullscreenButton.addEventListener('click', function () {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (media.requestFullscreen) {
        media.requestFullscreen();
      } else if (video.requestFullscreen) {
        video.requestFullscreen();
      }
    });

    progress.addEventListener('input', seekFromInput);
    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('durationchange', updateDuration);
    video.addEventListener('loadedmetadata', function () {
      updateDuration();
      updateProgress();
    });
    video.addEventListener('play', updatePlayState);
    video.addEventListener('pause', updatePlayState);
    video.addEventListener('volumechange', updateMuteState);
    document.addEventListener('fullscreenchange', updateFullscreenState);
    video.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    updatePlayState();
    updateMuteState();
    updateDuration();
    updateProgress();
    updateFullscreenState();
  }

  function watchMedia(media) {
    if (!media) return;

    const trySetup = function () {
      ensureControls(media);
    };

    if (media.querySelector('video')) {
      trySetup();
      return;
    }

    const observer = new MutationObserver(function () {
      if (media.querySelector('video')) {
        observer.disconnect();
        trySetup();
      }
    });

    observer.observe(media, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-custom-video-controls="true"]').forEach(watchMedia);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
